/* Header - Recalcul hauteur sticky via ResizeObserver */
(function () {
  function updateHeaderHeight(header) {
    const rect = header.getBoundingClientRect();
    document.documentElement.style.setProperty(
      '--header-height',
      rect.height + 'px'
    );
  }

  document.addEventListener('DOMContentLoaded', function () {
    const header = document.querySelector('.section-header');
    if (!header) return;

    updateHeaderHeight(header);

    const observer = new ResizeObserver(function () {
      updateHeaderHeight(header);
    });

    observer.observe(header);
  });
})();
